var map = {
	"./abb-color.svg": 1775,
	"./afb-color.svg": 1776,
	"./afb.svg": 1777,
	"./agro-color.svg": 1778,
	"./alb-color.svg": 1779,
	"./alb.svg": 1780,
	"./amb-color.svg": 1781,
	"./amb.svg": 1782,
	"./bbbaidja-color.svg": 1783,
	"./bbbaidjaxxx-color.svg": 1784,
	"./bdinidjaxxx-color.svg": 1785,
	"./bimb-color.svg": 1786,
	"./bimb.svg": 1787,
	"./bkr-color.svg": 1788,
	"./bkr.svg": 1789,
	"./bmriidja-color.svg": 1790,
	"./bniaidja-color.svg": 1791,
	"./bninidja-color.svg": 1792,
	"./bninidjaxxx-color.svg": 1793,
	"./boc-color.svg": 1794,
	"./bpay-color.svg": 1795,
	"./brinidja002-color.svg": 1796,
	"./bsmdidjaxxx-color.svg": 1797,
	"./bsn-color.svg": 1798,
	"./bsn.svg": 1799,
	"./btanidjaxxx-color.svg": 1800,
	"./cenaidja-color.svg": 1801,
	"./cenaidjaxxx-color.svg": 1802,
	"./cimb-color.svg": 1803,
	"./cimb.svg": 1804,
	"./citi-color.svg": 1805,
	"./citi.svg": 1806,
	"./default-bank-icon-color.png": 1807,
	"./default-bank-icon.png": 1808,
	"./gxbank-color.svg": 1809,
	"./hlb-color.svg": 1810,
	"./hlb.svg": 1811,
	"./hsbc-color.svg": 1812,
	"./hsbc.svg": 1813,
	"./ibbkidjaxxx-color.svg": 1814,
	"./kfh-color.svg": 1815,
	"./kwh-color.svg": 1816,
	"./kwh.svg": 1817,
	"./mbb-color.svg": 1818,
	"./mbb.svg": 1819,
	"./muamalat-color.svg": 1820,
	"./nispidjaxxx-color.svg": 1821,
	"./ocbc-color.svg": 1822,
	"./ocbc.svg": 1823,
	"./pbb-color.svg": 1824,
	"./pbb.svg": 1825,
	"./pinbidja-color.svg": 1826,
	"./raykat-color.svg": 1827,
	"./rhb-b.svg": 1828,
	"./rhb-color-b.svg": 1829,
	"./rhb-color.svg": 1830,
	"./rhb.svg": 1831,
	"./scb-color.svg": 1832,
	"./scb.svg": 1833,
	"./tng-color.svg": 1834,
	"./uob-color.svg": 1835,
	"./uob.svg": 1836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;